export default function() {
  return {
    categories: [],
    categoriesSimplified: []
  };
}
